// frontend/stores/productSlice.js

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

console.log('productSlice: Initializing the product slice store with updates.');

export const useProductStore = create(
  devtools(
    persist(
      (set) => ({
        // Your original client-side state
        selectedProduct: null,
        selectedShop: null,
        
        // New state for the current product and its variants
        currentProduct: null,
        variantsForCurrentProduct: [],
        
        // NEW STATE FOR EDITING RECOMMENDED AND ACCESSORIES LISTS
        allGottenProducts: [],
        currentProductRecommendedList: [],
        currentProductAccessoriesList: [],
        currentPageRecommendedList: [],
        currentPageAccessoriesList: [],
        
        // Your original actions
        setSelectedProduct: (product) => {
          console.log('productSlice: Setting selected product.');
          set({ selectedProduct: product });
        },
        clearSelectedProduct: () => {
          console.log('productSlice: Clearing selected product.');
          set({ selectedProduct: null });
        },
        setSelectedShop: (shopId) => {
          console.log('productSlice: Setting selected shop.');
          set({ selectedShop: shopId });
        },
        clearSelectedShop: () => {
          console.log('productSlice: Clearing selected shop.');
          set({ selectedShop: null });
        },

        // New actions for the current product and its variants
        /**
         * Sets the current product in the store.
         * @param {Object} product - The product data to store.
         */
        setCurrentProduct: (product) => {
          console.log('productSlice: Setting current product in store.', { product });
          set({ currentProduct: product });
        },
        
        /**
         * Sets the variants for the current product.
         * @param {Array} variants - The variants data to store.
         */
        setVariantsForCurrentProduct: (variants) => {
          console.log('productSlice: Setting variants for current product in store.', { variants });
          set({ variantsForCurrentProduct: variants });
        },

        /**
         * Clears the current product and its variants from the store.
         */
        clearCurrentProduct: () => {
          console.log('productSlice: Clearing current product data from store.');
          set({
            currentProduct: null,
            variantsForCurrentProduct: [],
          });
        },

        // NEW ACTIONS FOR EDITING RECOMMENDED AND ACCESSORIES LISTS
        setAllGottenProducts: (products) => {
            console.log('productSlice: Setting all gotten products in store.');
            set({ allGottenProducts: products });
        },
        addMoreGottenProducts: (newProducts) => {
            console.log('productSlice: Adding more products to the gotten list.');
            set((state) => ({
                allGottenProducts: [...state.allGottenProducts, ...newProducts],
            }));
        },
        setCurrentProductRecommendedList: (products) => {
            console.log('productSlice: Setting current product recommended list.');
            set({ currentProductRecommendedList: products });
        },
        setCurrentProductAccessoriesList: (products) => {
            console.log('productSlice: Setting current product accessories list.');
            set({ currentProductAccessoriesList: products });
        },
        setCurrentPageRecommendedList: (products) => {
            console.log('productSlice: Setting current page recommended list.');
            set({ currentPageRecommendedList: products });
        },
        setCurrentPageAccessoriesList: (products) => {
            console.log('productSlice: Setting current page accessories list.');
            set({ currentPageAccessoriesList: products });
        },
      }),
      {
        name: 'product-storage', // Your original unique name for the storage key
        getStorage: () => localStorage, // Your original storage method
        partialize: (state) => ({
          // Retain your original partialization
          selectedProduct: state.selectedProduct,
          selectedShop: state.selectedShop,
          // Add the new state variables to be persisted
          currentProduct: state.currentProduct,
          variantsForCurrentProduct: state.variantsForCurrentProduct,
          allGottenProducts: state.allGottenProducts,
          currentProductRecommendedList: state.currentProductRecommendedList,
          currentProductAccessoriesList: state.currentProductAccessoriesList,
          currentPageRecommendedList: state.currentPageRecommendedList,
          currentPageAccessoriesList: state.currentPageAccessoriesList,
        }),
      }
    )
  )
);